export default __webpack_public_path__ + "static/media/photo_2022-05-15_11-02-34.17dbded6.jpg";